import React from "react";
import { Typography } from "@material-ui/core";
import FlexiForm, { Fields } from "../../FlexiComponents/FlexiForm";
import Grid from "@material-ui/core/Grid/Grid";

const StuckAtSignature = ({ onSubmit, formId }) => {
  const secondSectionRadios = [
    {
      fieldType: "radio",
      name: `quest2`,
      label: "1",
      value: "1"
    },
    {
      fieldType: "radio",
      name: `quest2`,
      label: "2",
      value: "2"
    },
    {
      fieldType: "radio",
      name: `quest2`,
      label: "3",
      value: "3"
    },
    {
      fieldType: "radio",
      name: `quest2`,
      label: "4",
      value: "4"
    },
    {
      fieldType: "radio",
      name: `quest2`,
      label: "5",
      value: "5"
    }
  ];

  return (
    <>
      <FlexiForm
        id={formId}
        FinalFormFormProps={{
          onSubmit
        }}
        render={({ values }) => (
          <div>
            <Typography variant={"h5"}>
              Mi volt az oka annak, hogy még nem írtad alá a szerződést?
            </Typography>
            <Grid item xs={6}>
              <Fields
                config={[
                  [
                    {
                      fieldType: "radio",
                      name: `quest1`,
                      label: "Nem volt egyértelmű a szerződés tartalma",
                      value: "a"
                    }
                  ],
                  [
                    {
                      fieldType: "radio",
                      name: `quest1`,
                      label: "Nem volt időm átolvasni",
                      value: "b"
                    }
                  ],
                  [
                    {
                      fieldType: "radio",
                      name: `quest1`,
                      label: "Aláírás alatt van",
                      value: "c"
                    }
                  ],
                  [
                    {
                      fieldType: "radio",
                      name: `quest1`,
                      label: "Más ok",
                      value: "d"
                    }
                  ]
                ]}
              />
              {values?.quest1 === "d" && (
                <Fields
                  config={[
                    [
                      {
                        fieldType: "text",
                        name: `freeText1`,
                        placeholder: "Kérjük, írj róla pár szót",
                        disabled: values?.quest1 !== "d"
                      }
                    ]
                  ]}
                />
              )}
            </Grid>
            <Typography variant={"h5"} style={{ paddingTop: "20px" }}>
              Mennyire volt érthető a szerződés tartalma? (1 - egyáltalán nem, 5
              - érthető volt)
            </Typography>
            <Grid item xs={6}>
              <Fields config={[secondSectionRadios]} />
            </Grid>
            <Typography variant={"h5"} style={{ paddingTop: "20px" }}>
              Mi segítene abban, hogy folytasd és aláírd a szerződést?
            </Typography>
            <Grid item xs={6}>
              <Fields
                config={[
                  [
                    {
                      fieldType: "radio",
                      name: `quest3`,
                      label: "Részletesebb magyarázat a szerződésről",
                      value: "a"
                    }
                  ],
                  [
                    {
                      fieldType: "radio",
                      name: `quest3`,
                      label: "Ügyfélszolgálati segítség",
                      value: "b"
                    }
                  ],
                  [
                    {
                      fieldType: "radio",
                      name: `quest3`,
                      label: "Egyéb",
                      value: "c"
                    }
                  ]
                ]}
              />
              {values?.quest3 === "c" && (
                <Fields
                  config={[
                    [
                      {
                        fieldType: "text",
                        name: `freeText2`,
                        placeholder: "Kérjük, írj róla pár szót",
                        disabled: values?.quest3 !== "c"
                      }
                    ]
                  ]}
                />
              )}
            </Grid>
          </div>
        )}
      />
    </>
  );
};

export default StuckAtSignature;
